import { Container } from '../../ui'
import cn from 'classnames'
import {useDispatch} from "react-redux";
import {openWindow} from "../../models/window/actions";
import {modalNames} from "../common/modal/constants/names";

import c from './assets/sass/footer.module.scss'

const Footer = () => {
    const dispatch = useDispatch()

    const bookHandler = () => {
        dispatch(openWindow(modalNames.CONTACT_MODAL))
    }

    const scrollToAbout = (e) => {
        e.preventDefault()

        document.getElementById('about')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToPrice = (e) => {
        e.preventDefault()

        document.getElementById('price')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToCategory = (id) => {
        window.dispatchEvent(
            new CustomEvent('price:scroll-to-category', {
                detail: {id},
            })
        )
    }

    return (
        <footer className={c.component}>
            <Container>
                <div className={c.row}>
                    <div className={c.copyrights}>
                        <span>2026 DL Massage All rights reserved</span>
                    </div>
                    <nav className={c.navigation}>
                        <div className={c.navBlock}>
                            <div className={c.navTitle}>О нас</div>
                            <ul className={c.navList}>
                                <li className={c.navItem}>
                                    <button className={c.navButton} onClick={scrollToAbout}>
                                        О нас
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button className={c.navButton} onClick={scrollToPrice}>
                                        Услуги
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button className={c.navButton} onClick={scrollToPrice}>
                                        Цены на процедуры
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button className={c.navButton} onClick={bookHandler}>
                                        Подарить сертификат
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div className={c.navBlock}>
                            <div className={c.navTitle}>Услуги</div>
                            <ul className={c.navList}>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('manualMassage')}
                                    >
                                        Массаж ручной
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('bodyCorrection')}
                                    >
                                        Аппаратная коррекция фигуры
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('facialRejuvenation')}
                                    >
                                        Омоложение лица
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('spaPrograms')}
                                    >
                                        Spa - программы
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('browServices')}
                                    >
                                        Бровист
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('depilation')}
                                    >
                                        Депиляция (воск, сахар)
                                    </button>
                                </li>
                                <li className={c.navItem}>
                                    <button
                                        className={c.navButton}
                                        onClick={() => scrollToCategory('solarium')}
                                    >
                                        Солярий
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    <div className={c.side}>
                        <div className={cn(c.sideTitle, c.willHide)}>
                            Контакты
                        </div>
                        <div className={c.contactItem}>
                            <div className={c.contactItemSide}>
                                <div className={c.contactItemTitle}>
                                    Контакты
                                </div>
                                <div className={c.number}>+7 985 665-62-94</div>
                            </div>
                            <button className={c.button} onClick={bookHandler}>Записаться</button>
                        </div>
                        <div className={c.contactItem}>
                            <div className={c.contactItemSide}>
                                <div className={c.contactItemTitle}>Адрес</div>
                                <div className={c.address}>
                                    Мск, Казакова дом 8 стр. 2
                                </div>
                            </div>
                            <a
                                href="https://yandex.ru/maps/-/CTC7jTpU"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={cn(c.button, c.route)}
                            >
                                Маршрут
                            </a>
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    )
}

export default Footer
